import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ClockIcon from '../../../Icons/Clock';
import Timestamp from '../../../Timestamp';
import { IconSize } from '../../../Icons/IconWrap';
import { useDeviationViewContext, MobileContext } from '../../../Context';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
import s from './Journal.scss';
var maxTitleLength = 84;
export var JournalFullView = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.deviation, title = _b.title, publishedTime = _b.publishedTime, textContent = _b.textContent;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var showDate = !isMobile;
    var isTheater = useDeviationViewContext().isTheater;
    var shortTitle = title && title.length > maxTitleLength
        ? title.slice(0, maxTitleLength - 3) + "..."
        : title;
    var minutes = getReadingTimeMinutes(textContent);
    return (React.createElement("div", { className: classnames(s['root'], isTheater && s['theater']), style: { width: width, height: height } },
        React.createElement("div", { className: s['center-wrap'] },
            React.createElement("div", { className: s['title-wrap'] },
                React.createElement("div", { className: s['title'] }, shortTitle),
                React.createElement("div", { className: s['subtitle'] },
                    showDate && (React.createElement("span", { className: s['published'] },
                        React.createElement(Timestamp, { timestamp: publishedTime }))),
                    !!minutes && (React.createElement(React.Fragment, null,
                        React.createElement(ClockIcon, { withPadding: true, className: s['clock'], size: IconSize.SMALL }),
                        React.createElement("span", null, t('deviationview.journal.stage.read', { count: minutes })))))))));
};
JournalFullView.displayName = 'JournalFullView';
export default JournalFullView;
//# sourceMappingURL=Journal.js.map